/*=========================================================================================
  File Name: moduleStaffState.js
  Description: Staff Module State
  ----------------------------------------------------------------------------------------
  Item Name: Speed HRM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default { 
}